import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { appContext } from "../context/ContextProvider";
// import BeneficiaryForm from "../pages/Beneficiary/components/AddBeneficiaryPersonalDataForm";

import Dashboard from "../pages/Dashboard/Dashboard";
import PreAuth from "../pages/PreAuth";
import Claims from "../pages/Claims";
import Communications from "../pages/Communications";
import Cancellation from "../pages/Cancellation";
import Physician from "../pages/Physicians";
import PriceList from "../pages/PriceList";
import PreAuthList from "../pages/PreAuth/PreAuthList";
import PreAuthForm from "../pages/PreAuth/components/PreAuthForm";
import Payments from "../pages/Payments";
import PaymentsList from "../pages/Payments/PaymentsList";
import Eligibility from "../pages/Eligibility";
import EligibilityList from "../pages/Eligibility/EligibilityList";
import Beneficiary from "../pages/Beneficiary";
import BeneficiaryForm from "../pages/Beneficiary/BeneficiaryForm";
import BeneficiaryList from "../pages/Beneficiary/BeneficiaryList";
import BeneficiaryDetails from "../pages/Beneficiary/BeneficiaryDetails";
import EligibilityDetails from "../pages/Eligibility/components/responseEligbility/EligibilityDetails";
import PreAuthDetails from "../pages/PreAuth/components/PreAuthDetails";
import ClaimsList from "../pages/Claims/ClaimsList";
import SubmitClaims from "../pages/Claims/SubmitClaims";
import ClaimsForm from "../pages/Claims/components/ClaimsForm";
import ClaimsDetails from "../pages/Claims/components/ClaimsDetails";
import EditBeneficiaryForm from "../pages/Beneficiary/EditBeneficiaryForm";
import PhysiciansList from "../pages/Physicians/PhysiciansList";
import PhysiciansForm from "../pages/Physicians/PhysiciansForm";
import PriceListMain from "../pages/PriceList/PriceListMain";
import PriceListSpecificPayer from "../pages/PriceList/PriceListSpecificPayer";
import ClaimHistoryList from "../pages/Claims/ClaimHistoryList";
import ClaimUploadList from "../pages/Claims/ClaimUploadList";
import ClaimsSubmitStats from "../pages/Claims/components/ClaimsSubmitStats";
import CommunicationsList from "../pages/Communications/CommunicationsList";
import CancellationList from "../pages/Cancellation/CancellationList";
import GssReportMain from "../pages/Claims/gssReport/GssReportMain";
import ClaimReportMain from "../pages/Claims/claimReport/ClaimReportMain";
import SuperAdmin from "../pages/SuperAdmin/index";
import SuperAdminDashboard from "../pages/SuperAdmin/Dashboard/SuperAdminDashboard";
import UserManagement from "../pages/SuperAdmin/UserManagment/UserManagement";
import PreAuthUpdate from "../pages/SuperAdmin/PreAuthUpdate/PreAuthUpdate";
import SfdaMedicineList from "../pages/SuperAdmin/SfdaMedicine/SfdaMedicineList";
import SfdaMedicineForm from "../pages/SuperAdmin/SfdaMedicine/SfdaMedicineForm";

import Ocr from "../pages/ocr/Ocr";
import OcrMain from "../pages/ocr/components/OcrMain";
import AdvancePreAuth from "../pages/PreAuth/AdvancePreAuth";
import DenialManagement from "../pages/Claims/DenialManagement";
import Reports from "../pages/Eligibility/components/reports/Reports";
import Manager from "../pages/PreAuth/components/manager/Manager";
import Report from "../pages/PreAuth/components/report/Report";
import ClaimReports from "../pages/Claims/reports/ClaimReports";
import Index from "../pages/payermanagement/Index";
import Policy from "../pages/policy";
import MainReports from "../pages/Reports";
import PayerManagement from "../pages/payermanagement/PayerManagement";
import MainPage from "../pages/policy/MainPage";
import ReportCard from "../pages/Reports/ReportCard";
import PayerManagementForm from "../pages/payermanagement/PayerManagementForm";
import NPR from "../pages/npr/index";
import NprPayerLevel from "../pages/npr/NprPayerLevel";
import NprPolicyLevel from "../pages/npr/NprPolicyLevel";
import CreatePriceListForm from "../pages/PriceList/CreatePriceListForm";
import ClaimsProcessing from "../pages/Claims/ClaimsProcessing";
import UnderDevelopment from "../shared/UnderDevelopment";
import ReportSummary from "../pages/reports-summary/ReportSummary";
import HelpDeskIndex from "../pages/helpDesk/index";
import HelpDesk from "../pages/helpDesk/HelpDesk";
import AramcoHelpDesk from "../pages/helpDesk/AramcoHelpDesk";
import AdvancePreAuthDetails from "../pages/PreAuth/AdvancePreAuthDetails";
import PaymentDetails from "../pages/Payments/PaymentDetails";
import ClaimErrorList from "../pages/Claims/ClaimErrorList";

// import MainDash from "../pages/Dashboard/components/MainDash/MainDash";

function Router(props) {
  const { user, setUser, setToken, setPermissions, permissions } =
    useContext(appContext);
  return (
    <Routes>
      <Route
        path="dashboard"
        element={user?.RoleId == "12" ? <SuperAdminDashboard /> : <Dashboard />}
      >
        {/* <Route index element={<MainDash />} /> */}
      </Route>
      <Route path="beneficiary" element={<Beneficiary />}>
        <Route index element={<BeneficiaryList />} />
        <Route path="form" element={<BeneficiaryForm />} />
        <Route path="edit/form" element={<EditBeneficiaryForm />} />
        <Route path="details" element={<BeneficiaryDetails />} />
      </Route>
      <Route path="eligibility" element={<Eligibility />}>
        <Route index element={<EligibilityList />} />
        <Route path="details" element={<EligibilityDetails />} />
        <Route path="reports" element={<Reports />} />
      </Route>
      <Route path="preauth" element={<PreAuth />}>
        <Route index element={<PreAuthList />} />
        <Route path="form" element={<PreAuthForm />} />
        <Route path="details" element={<PreAuthDetails />} />
        <Route path="details/:id" element={<PreAuthDetails />} />
        <Route path="edit/form/:id" element={<PreAuthForm />} />
        <Route path="edit/form/:id/:followUp" element={<PreAuthForm />} />
        <Route path="advance/preauth" element={<AdvancePreAuth />} />
        <Route
          path="advance/preauth/details"
          element={<AdvancePreAuthDetails />}
        />
        <Route path="manager" element={<Manager />} />
        <Route path="report" element={<Report />} />
        <Route path="report/pre-auth" element={<UnderDevelopment />} />
        <Route path="report/approved" element={<UnderDevelopment />} />
        <Route path="report/rejected" element={<UnderDevelopment />} />
        <Route path="report/impacts" element={<UnderDevelopment />} />
        <Route path="report/impacts/kpi" element={<UnderDevelopment />} />
      </Route>
      <Route path="npr" element={<NPR />}>
        <Route index path="payer-level" element={<NprPayerLevel />} />
        <Route index path="policy-level" element={<NprPolicyLevel />} />
      </Route>
      <Route path="claims" element={<Claims />}>
        <Route index element={<ClaimsList />} />
        <Route path="submit" element={<SubmitClaims />} />
        <Route path="form" element={<ClaimsForm />} />
        <Route path="edit/form/:id" element={<ClaimsForm />} />
        <Route path="edit/form/:id/:followUp" element={<ClaimsForm />} />
        <Route path="details" element={<ClaimsDetails />} />
        <Route path="details/:id" element={<ClaimsDetails />} />
        <Route path="history" element={<ClaimHistoryList />} />
        <Route path="gss-report" element={<GssReportMain />} />
        <Route path="claim-report" element={<ClaimReportMain />} />
        <Route path="uploads" element={<ClaimUploadList />} />
        <Route path="submit-stats" element={<ClaimsSubmitStats />} />
        <Route path="denial/management" element={<DenialManagement />} />
        <Route path="report" element={<ClaimReports />} />
        <Route path="processing" element={<ClaimsProcessing />} />
        <Route path="error-list" element={<ClaimErrorList />} />

      </Route>
      <Route path="communications" element={<Communications />}>
        <Route index element={<CommunicationsList />} />
      </Route>
      <Route path="policy" element={<Policy />}>
        <Route index element={<MainPage />} />
      </Route>
      <Route path="payer-managment" element={<Index />}>
        <Route index element={<PayerManagement />} />
        <Route path="form" element={<PayerManagementForm />} />
      </Route>
      <Route path="cancellation" element={<Cancellation />}>
        <Route index element={<CancellationList />} />
      </Route>
      <Route path="physicians" element={<Physician />}>
        <Route index element={<PhysiciansList />} />
        <Route path="form" element={<PhysiciansForm />} />
        <Route path="edit/form/:id" element={<PhysiciansForm />} />
      </Route>

      <Route path="/help-desk" element={<HelpDeskIndex />}>
        <Route index element={<HelpDesk />} />
        <Route path="aramco" element={<AramcoHelpDesk />} />
      </Route>
      <Route path="price-list" element={<PriceList />}>
        <Route index element={<PriceListMain />} />

        <Route path="form" element={<CreatePriceListForm />} />
        <Route
          path="specific/:payerId/:effectiveDate/:payerName"
          element={<PriceListSpecificPayer />}
        />
      </Route>
      <Route path="payments" element={<Payments />}>
        <Route index element={<PaymentsList />} />
        <Route path='details' element={<PaymentDetails />} />
      </Route>
      <Route path="reports" element={<MainReports />}>
        <Route index element={<ReportCard />} />
      </Route>
      <Route path="ocr" element={<Ocr />}>
        <Route index element={<OcrMain />} />
      </Route>
      <Route path="super-admin" element={<SuperAdmin />}>
        <Route path="user-management" element={<UserManagement />} />
        <Route path="preauth-update" element={<PreAuthUpdate />} />
        <Route path="sfda-medicine">
          <Route index element={<SfdaMedicineList />} />
          <Route path="form" element={<SfdaMedicineForm />} />
        </Route>
      </Route>
      <Route path="reports-summary" element={<ReportSummary />} />
      <Route path="*" element={<Navigate to="dashboard" />} />
    </Routes>
  );
}

export default Router;
